import VatDefinitionList from './VatDefinitionList';
import VatDefinitionCreate from './VatDefinitionCreate';
import VatDefinitionEdit from './VatDefinitionEdit';

const vatDefinitions = {
	list: VatDefinitionList,
	create: VatDefinitionCreate,
	edit: VatDefinitionEdit
};

export default vatDefinitions;
